const styles = theme => ({
  toolbarFlexStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },
  courseTitleStyle: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#002E47',
    marginBottom: '3px',
    fontFamily: 'Inter',
  },
  textfield: {
    '& fieldset': { border: 'none' },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        border: '1px solid #002E47',
      },
      '&.Mui-focused fieldset': {
        border: '1px solid #015ffb',
      },
    },
    maxWidth: '400px',
    width: '100%',
    padding: 0,
  },
  textfieldInput: {
    color: '#002E47',
    fontFamily: 'Inter',
    fontSize: '14px',
    padding: 0,
  },
  customWidth: {
    backgroundColor: '#fff',
  },
  // Grey rather than coloured: a draft is not a warning, it is simply not out yet.
  draftBadge: {
    backgroundColor: '#F4F6F8',
    color: '#637381',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '6px',
    padding: '2px 10px',
    whiteSpace: 'nowrap',
  },
  publishChangesLabel: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
  },
  // Sits on the corner of the label so the button reads as "something is waiting" at a glance.
  pendingDot: {
    position: 'absolute',
    top: '-4px',
    right: '-10px',
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#FF9800',
  },
  publishPromptTitle: {
    fontFamily: 'Inter',
    fontSize: '15px',
    fontWeight: 700,
    color: '#212B36',
    marginBottom: '8px',
  },
  publishPromptBody: {
    fontFamily: 'Inter',
    fontSize: '13px',
    color: '#637381',
    marginBottom: '16px',
  },
  publishPromptActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
  },
})

export default styles
